module.exports = __webpack_public_path__ + "static/media/trailer_layer1.4ce863c2.jpg";